module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-add-1e01b50a1cb544d13f50670f7ac30279.svg";